import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/tmp/build_fbe76f3a/apps/open/src/app/auth/_components/Form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/tmp/build_fbe76f3a/apps/open/src/app/auth/_components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwitchPlatformButton"] */ "/tmp/build_fbe76f3a/apps/open/src/app/auth/_components/SwitchPlatformButton.tsx");
